
    import './styles.scoped.css';
    export default {
  "grid": "awsui_grid_14yj0_1mohw_99",
  "no-gutters": "awsui_no-gutters_14yj0_1mohw_138",
  "grid-column": "awsui_grid-column_14yj0_1mohw_143",
  "colspan-1": "awsui_colspan-1_14yj0_1mohw_154",
  "push-1": "awsui_push-1_14yj0_1mohw_158",
  "pull-1": "awsui_pull-1_14yj0_1mohw_161",
  "colspan-2": "awsui_colspan-2_14yj0_1mohw_164",
  "push-2": "awsui_push-2_14yj0_1mohw_168",
  "pull-2": "awsui_pull-2_14yj0_1mohw_171",
  "colspan-3": "awsui_colspan-3_14yj0_1mohw_174",
  "push-3": "awsui_push-3_14yj0_1mohw_178",
  "pull-3": "awsui_pull-3_14yj0_1mohw_181",
  "colspan-4": "awsui_colspan-4_14yj0_1mohw_184",
  "push-4": "awsui_push-4_14yj0_1mohw_188",
  "pull-4": "awsui_pull-4_14yj0_1mohw_191",
  "colspan-5": "awsui_colspan-5_14yj0_1mohw_194",
  "push-5": "awsui_push-5_14yj0_1mohw_198",
  "pull-5": "awsui_pull-5_14yj0_1mohw_201",
  "colspan-6": "awsui_colspan-6_14yj0_1mohw_204",
  "push-6": "awsui_push-6_14yj0_1mohw_208",
  "pull-6": "awsui_pull-6_14yj0_1mohw_211",
  "colspan-7": "awsui_colspan-7_14yj0_1mohw_214",
  "push-7": "awsui_push-7_14yj0_1mohw_218",
  "pull-7": "awsui_pull-7_14yj0_1mohw_221",
  "colspan-8": "awsui_colspan-8_14yj0_1mohw_224",
  "push-8": "awsui_push-8_14yj0_1mohw_228",
  "pull-8": "awsui_pull-8_14yj0_1mohw_231",
  "colspan-9": "awsui_colspan-9_14yj0_1mohw_234",
  "push-9": "awsui_push-9_14yj0_1mohw_238",
  "pull-9": "awsui_pull-9_14yj0_1mohw_241",
  "colspan-10": "awsui_colspan-10_14yj0_1mohw_244",
  "push-10": "awsui_push-10_14yj0_1mohw_248",
  "pull-10": "awsui_pull-10_14yj0_1mohw_251",
  "colspan-11": "awsui_colspan-11_14yj0_1mohw_254",
  "push-11": "awsui_push-11_14yj0_1mohw_258",
  "pull-11": "awsui_pull-11_14yj0_1mohw_261",
  "colspan-12": "awsui_colspan-12_14yj0_1mohw_264",
  "push-12": "awsui_push-12_14yj0_1mohw_268",
  "pull-12": "awsui_pull-12_14yj0_1mohw_271",
  "push-0": "awsui_push-0_14yj0_1mohw_274",
  "pull-0": "awsui_pull-0_14yj0_1mohw_277",
  "offset-1": "awsui_offset-1_14yj0_1mohw_280",
  "offset-2": "awsui_offset-2_14yj0_1mohw_283",
  "offset-3": "awsui_offset-3_14yj0_1mohw_286",
  "offset-4": "awsui_offset-4_14yj0_1mohw_289",
  "offset-5": "awsui_offset-5_14yj0_1mohw_292",
  "offset-6": "awsui_offset-6_14yj0_1mohw_295",
  "offset-7": "awsui_offset-7_14yj0_1mohw_298",
  "offset-8": "awsui_offset-8_14yj0_1mohw_301",
  "offset-9": "awsui_offset-9_14yj0_1mohw_304",
  "offset-10": "awsui_offset-10_14yj0_1mohw_307",
  "offset-11": "awsui_offset-11_14yj0_1mohw_310",
  "restore-pointer-events": "awsui_restore-pointer-events_14yj0_1mohw_314"
};
  